var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel",class:_vm.params.bgType === 1 ? 'bgcolor1' : ''},[_c('h2',{staticClass:"panel-title"},[_c('span',[_vm._v(_vm._s(_vm.params.title))]),_c('small',[_vm._v(_vm._s(_vm.params.subTitle))])]),_c('div',{staticClass:"panel-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }